if (!customElements.get('offer-selector')) {
  customElements.define(
    'offer-selector',
    class OfferSelector extends HTMLElement {
      constructor() {
        super();

        this.onTierChange = this.onTierChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.onTierChange);

        // With tiers, the Buy buttons form is rendered with this product's own variant, so point it at the
        // checked tier. Without tiers there are no radios, and this element carries the product price instead.
        const checkedTier = this.querySelector('.offer-selector__input:checked');
        if (checkedTier) this.setVariant(checkedTier.value);
        this.updateButtonPrice(checkedTier ? checkedTier.dataset.price : this.dataset.price);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onTierChange);
      }

      onTierChange(event) {
        const tierInput = event.target;
        if (!tierInput.matches('.offer-selector__input')) return;

        this.setVariant(tierInput.value);
        this.updateButtonPrice(tierInput.dataset.price);
        this.productForm?.handleErrorMessage?.();
      }

      setVariant(variantId) {
        const input = this.form?.querySelector('input[name="id"]');
        if (!input || input.value === variantId) return;

        input.value = variantId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateButtonPrice(price) {
        const suffix = this.dataset.buttonPriceSuffix;
        const label = this.productForm?.querySelector('button[type="submit"] > span');
        if (!suffix || !price || !label || !window.variantStrings) return;

        label.textContent = `${window.variantStrings.addToCart} ${suffix.replace('[price]', price)}`;
      }

      get form() {
        return document.getElementById(this.dataset.productFormId);
      }

      get productForm() {
        return this.form?.closest('product-form');
      }
    }
  );
}
